module.exports = function(h, row) {
    let name = row.name;
    let color = row.color != null ? row.color : '#000000';
    let outletStyle =
        row.color != null ? '2px solid ' + row.color : '2px solid #000000';
    let filter = ['::'];

    let scopes = _.some(filter, el => _.includes(name, el));

    let badge = (
        <div class="badge" data-color="light">
            <div class="badge-text" style={{ backgroundColor: color }}>
                <span>{name}</span>
            </div>
        </div>
    );

    if (scopes) {
        let split = name.split('::');
        let second = split[split.length - 1];
        let first_data = _.dropRight(split);
        const first = _.join(first_data, '::');
        badge = (
            <div class="badge" data-color="light">
                <div class="badge-text-left" style={{ backgroundColor: color }}>
                    <span>{first}</span>
                </div>
                <div class="badge-text-right" style={{ outline: outletStyle }}>
                    <span>{second}</span>
                </div>
            </div>
        );
    }

    return badge;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/label/label-badge.jsx